import posthog from "posthog-js";
import { Router } from "vue-router";

const BLOCKED_PATH_REGEX = /^\/experts_booking_system/;

export function setupPosthogSessionReplay(router: Router) {
  if (!posthog.__loaded) {
    return;
  }
  router.afterEach((to) => {
    if (BLOCKED_PATH_REGEX.test(to.path)) {
      posthog.stopSessionRecording();
    } else {
      posthog.startSessionRecording();
    }
  });
}
